import { Subject } from 'rxjs';

import { Injectable } from '@angular/core';

// import { ControlDetailAttributeValue } from '../shared/app-consts';
// interface ReceivedMessage {
//   action: string;
//   newData: ControlDetailAttributeValue;
// }

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private socket?: WebSocket;
  currentAccountID?: string = '';
  controlUpdate = new Subject<{ accountId: string, controlId: string, status: number }>();

  constructor() { }

  connect(url: string): void {
    this.socket = new WebSocket(url);

    this.socket.onopen = (event) => {
      console.log('WebSocket is connected:', event);
      setInterval(() => {
        this.socket?.send('ping');
        console.log('Sent ping');
      }, 25000);
    };

    this.socket.onmessage = (event: MessageEvent<string>) => {
      const data = JSON.parse(event.data);
      if (data.message === 'pong') {
        console.log('Received pong');

      } else if (data.newData && data.newData.AccountID) {
        const AccountID = data.newData.AccountID.S;
        const ControlID = data.newData.ControlID.S;
        const Status = parseInt(data.newData.Status.N);

        if (AccountID === this.currentAccountID || this.currentAccountID === '') {
          this.controlUpdate.next({ accountId: AccountID, controlId: ControlID, status: Status });
        }

      } else {
        console.error('Invalid message format:', data);
      }
      // this.processData(data);  // データ処理
      // this.updatePaginator(); // ページネーター更新
      // this.cdr.detectChanges(); // 変更検出の強制
    };

    this.socket.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    this.socket.onclose = (event) => {
      console.log('WebSocket is closed:', event);
    };
  }

  sendMessage(message: string): void {
    this.socket?.send(message);
  }

  close(): void {
    if (this.socket) {
      this.socket.close();
    }
  }
}
